import { cva } from 'class-variance-authority';

const tableBaseStyles = ['w-full', 'text-sm', 'text-left', 'rtl:text-right'];

const tableStylesSAG = cva([
  ...tableBaseStyles,

  'text-[#000028]',
  'dark:text-white',
]);

const tableStylesSHS = cva([
  ...tableBaseStyles,
  'text-[#1a1a1a]',
  'dark:text-[#e6e6e6]',
]);

export { tableStylesSAG, tableStylesSHS };
